module.exports = __webpack_public_path__ + "images/bannerEN-1d10c8dd330142faa2c045e8b2cad336.jpg";